import { formatDateToYMD } from '@shared/utils/formatDate';

function parseDate(value) {
  if (!value) return null;

  const normalized = String(value).replace(/[-.]/g, '');
  const y = Number(normalized.slice(0, 4));
  const m = Number(normalized.slice(4, 6)) - 1;
  const d = Number(normalized.slice(6, 8));

  return new Date(y, m, d);
}

export function checkVacationOverlap({ formData, existingVacations }) {
  const newStart = formatDateToYMD(new Date(formData.startDate));
  const newEnd = formatDateToYMD(new Date(formData.endDate));
  const newCcType = formData.vacationDivision;

  return existingVacations.some((vac) => {
    const exStart = vac.start_date;
    const exEnd = vac.end_date;

    const exCcType = typeof vac.cc_type === 'string' ? vac.cc_type : vac.cc_type?.type;

    const vState = Number(vac.state);

    if (![1, 2, 3].includes(vState)) return false;

    const isDateOverlapped =
      parseDate(newStart) <= parseDate(exEnd) && parseDate(exStart) <= parseDate(newEnd);

    if (!isDateOverlapped) return false;

    const isConflict = exCcType === 'A01' || newCcType === 'A01' || exCcType === newCcType;

    return isConflict;
  });
}
